import { observer } from 'mobx-react-lite'
import React from 'react'

import { BrandImage } from '@/components/BrandImage'
import { DisplayGameCode } from '@/components/DisplayGameCode'
import { JumbotronVideoMusic } from '@/components/video/JumbotronVideoMusic'

import { useGameContext } from '../../context/game-context'
import { ContentStyled, OverlayStyled, VideoContainerStyled } from '../VideoOverlay'
import { CurrentColumnName } from './CurrentColumnName'
import { DisplayQrCode } from './DisplayQrCode'
import { PreviousSongs } from './PreviousSongs'

export const JumbotronMusic = observer(function JumbotronMusic({
  showCurrentLetter,
  showGameInfo
}: {
  showCurrentLetter: boolean
  showGameInfo: boolean
}): React.ReactElement {
  const { gameData } = useGameContext()

  if (gameData.type !== 'music') throw new Error(`Game type music be 'music'`)

  const {
    enableBrandImage,
    enableGameCode,
    enablePreviousSongs,
    enableQRCode,
    enableQRCodeFullscreen
  } = gameData.jumbotron

  const showPreviousSongs = Boolean(gameData.currentItemIndex) && enablePreviousSongs

  const showOverlay = [
    enableBrandImage,
    enableGameCode,
    enablePreviousSongs,
    enableQRCode,
    showCurrentLetter,
    showPreviousSongs
  ].some(setting => setting === true)

  return (
    <VideoContainerStyled>
      <JumbotronVideoMusic />

      {showOverlay && <OverlayStyled />}

      {showGameInfo && (
        // eslint-disable-next-line tailwindcss/no-custom-classname
        <ContentStyled className='game-info-container'>
          {enableBrandImage && <BrandImage className='m-auto mb-6' />}
          {enableGameCode && <DisplayGameCode />}
          {enableQRCode && <DisplayQrCode className='mx-auto mt-6 rounded-xl' />}
          {showCurrentLetter && <CurrentColumnName className='mt-6' />}
        </ContentStyled>
      )}

      {showPreviousSongs && (
        // eslint-disable-next-line tailwindcss/no-custom-classname
        <ContentStyled className='playlist-container'>
          <PreviousSongs />
        </ContentStyled>
      )}

      {enableQRCode && enableQRCodeFullscreen && <DisplayQrCode isFullscreen />}
    </VideoContainerStyled>
  )
})
